import { factory } from "typescript";
var JsxFileContext = /** @class */ (function () {
    function JsxFileContext() {
    }
    JsxFileContext.prototype.uniqueImports = function () {
        return [];
    };
    JsxFileContext.prototype.useHook = function (hook) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        // TODO unique import
        return null;
    };
    JsxFileContext.prototype.tag = function (tag) {
        var children = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            children[_i - 1] = arguments[_i];
        }
        // TODO unique import
        return null;
    };
    JsxFileContext.prototype.returnFragment = function () {
        var children = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            children[_i] = arguments[_i];
        }
        if ((children === null || children === void 0 ? void 0 : children.length) == 1) {
            // TODO handle one child
        }
        factory.createReturnStatement(factory.createJsxFragment(factory.createJsxOpeningFragment(), children, factory.createJsxJsxClosingFragment()));
        return null;
    };
    return JsxFileContext;
}());
export { JsxFileContext };
